import { FC } from "react";
import type { UserDTO } from "entities/user";
import { ChangeEmailModal } from "features/change-email";
import { ChangePasswordModal } from "features/change-password";
import { EditUserNamesModal } from "./EditUserNamesModal";

export type ProfileModal = "email" | "names" | "password" | null;

interface Props {
  modal: ProfileModal;
  profile: UserDTO;
  onClose: () => void;
}

export const ProfileModals: FC<Props> = ({ modal, profile, onClose }) => {
  switch (modal) {
    case "email":
      return (
        <ChangeEmailModal
          currentEmail={profile.contact_email.value}
          onClose={onClose}
        />
      );
    case "names":
      return (
        <EditUserNamesModal
          firstName={profile.legal_name.first_name}
          lastName={profile.legal_name.last_name}
          onClose={onClose}
        />
      );
    case "password":
      return <ChangePasswordModal onClose={onClose} />;
    default:
      return null;
  }
};
